<template>
    <div class="schedule" v-if="courseVO">
      <ScheduleHeader :courseVO="courseVO"/>
      <div class="schedule-wrapper">
        <!--      <ScheduleNav :courseVO="courseVO" :plans="plans"></ScheduleNav>-->
        <ScheduleContent :course-id="courseVO.id" :plans="plans" :currentPlan="currentPlan"></ScheduleContent>
      </div>
    </div>
</template>
<script setup>
import {onBeforeMount, computed} from 'vue';
import ScheduleNav from "@/pages/Schedule/components/ScheduleNav.vue";
import ScheduleContent from "@/pages/Schedule/components/ScheduleContent.vue";
import useCourseSchedule from "@/composables/useCourseSchedule";
import {useRoute} from "vue-router";
import ScheduleHeader from "@/pages/Schedule/components/ScheduleHeader.vue";

const route = useRoute()
const {courseVO, plans, getCourseSchedule} = useCourseSchedule()
const now = new Date();
const currentPlan = computed(() => plans.value.find(plan => (now >= plan.startTime && now <= plan.endTime)) || plans.value[0]);

onBeforeMount(() => {
  const courseId = route.params && route.params.courseId
  getCourseSchedule(+courseId)
})
</script>
<style lang="less" scoped>
@import "./variables";
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.schedule {
  overflow-anchor:none;
  min-height:100vh;
  background-color: #F4F4F4;

  .schedule-header {
    width: 100vw;
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .schedule-wrapper {
    width: 1100px;
    margin: 0 auto;
    padding: 70px 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
